import { createContext } from "react";

export const TypeContext = createContext('');